import React, { useState } from "react";
import { Backdrop, Box, Fade, Modal } from "@material-ui/core";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import CheckType from "./components/CheckType";

const style = {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  backgroundColor: "white",
  borderRadius: 4,
  gap: "20px",
};

const AttachmentViewer = ({ openModal, handleClose, url, attachmentName }) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotprops={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModal}>
        <Box className={"d-flex flex-column position-absolute p-4"} sx={style}>
          {/* begin::Header */}
          <Box className={"d-flex justify-content-end"}>
            <button
              type="button"
              className={"border-0 bg-transparent p-0"}
              onClick={handleClose}
            >
              <SVG
                style={{ width: 45 }}
                src={toAbsoluteUrl("/media/svg/icons/Files/Close.svg")}
              />
            </button>
          </Box>
          {/* end::Header */}

          {/* begin::Body */}
          <Box className={"d-flex justify-content-center"}>
            <CheckType url={url} attachmentName={attachmentName} />
          </Box>
          {/* end::Body */}

          {/* begin::Footer */}
          <Box className={"d-flex justify-content-end"}>
            <a
              download={attachmentName}
              href={url}
              target={"_blank"}
              className={"btn btn-pill p-2 bg-gray-400 bg-hover-gray-500"}
            >
              دانلود فایل
              <SVG
                style={{ width: 45 }}
                src={toAbsoluteUrl("/media/svg/icons/Files/Download.svg")}
              />
            </a>
          </Box>
          {/* end::Footer */}
        </Box>
      </Fade>
    </Modal>
  );
};

export default AttachmentViewer;
